import { getListCategory, getCategory } from '$services/goods'
// import cache from './../../utils/cache'

export default {
  namespaced: true,
  state: {
    indexActive: 'default',
    listCategory: [],
    categoryGoods: {},
    indexSwiper: false // 页面是否在滑动
  },
  getters: {
    activeMeta: (state) => {
      // 当前active的栏目的index、classid、page、location
      const index = state.listCategory.findIndex(obj => obj.code === state.indexActive)
      if (index === -1) {
        state.indexActive = 'default'
        return 0
      }
      return index
    }
  },
  mutations: {
    update_indexSwiper(state, val) {
      state.indexSwiper = val
    },
    update_indexActive(state, val) {
      state.indexActive = val
      // cache.setSession('index_Active', val)
    },
    update_listCategory(state, data) {
      // 接口请求成功数据处理
      state.listCategory = data
    },
    update_categoryGoods(state, data) {
      state.categoryGoods = data
    },
  },
  actions: {
    // 获取好物类别
    get_listCategory({ commit }) {
      return getListCategory({ numberOfGoods: 4 }).then((data) => {
        if (data) {
          commit('update_listCategory', data)
        }
        return data
      })
    },
    // 获取某个好物类别下所有产品
    get_categoryGoods({ commit }, { categoryCode, pageNo, pageSize }) {
      return getCategory({ categoryCode, pageNo, pageSize }).then((data) => {
        if (data) {
          commit('update_categoryGoods', data)
        }
        return data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/list.js